import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaMoon, FaSun } from 'react-icons/fa';

const HeaderLandingPage = ({ isDarkMode, toggleDarkMode }) => {
  return (
    <nav className="backdrop-blur-lg bg-white/70 dark:bg-gray-900/70 fixed w-full z-50 shadow-sm border-b border-gray-200/50 dark:border-gray-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/">
              <img
                src="/cashsule_new.png" 
                alt="Cashsule Icon"
                className="h-8 w-auto sm:h-10"
              />
            </Link>
            <h1 className="ml-2 sm:ml-3 text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">
              Cashsule
            </h1>
          </div>
          <div className="flex items-center space-x-2 sm:space-x-4">
            <button
              onClick={toggleDarkMode}
              className="p-2 rounded-full bg-gray-100/80 dark:bg-gray-800/80 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
              aria-label="Toggle dark mode"
            >
              {isDarkMode ? <FaSun className="h-5 w-5" /> : <FaMoon className="h-5 w-5" />}
            </button>
            <Link
              to="/login"
              className="px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg text-primary-600 dark:text-primary-400 hover:bg-gray-100/80 dark:hover:bg-gray-800/80 transition-colors text-sm sm:text-base"
            >
              Log in
            </Link>
            <Link
              to="/register"
              className="px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg bg-primary-600 text-white hover:bg-primary-700 transition-colors text-sm sm:text-base"
            >
              Sign up
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default HeaderLandingPage; 